/**
 * @fileoverview GET handler for the "/engagement/segments_count" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementSegmentsCount } from "./constants";
import type { SegmentsCountResult } from "./types";

export const getEngagementSegmentsCount = reactQueryFetcherAdapter(
  engagementSegmentsCount,
  (signal: AbortSignal): Promise<SegmentsCountResult> => {
    return fetch("/engagement/segments_count", "GET", {}, { signal });
  }
);
